<template lang="html">

  <div class="wrapper -alumni">

    <div class="encabezado">

      <div class="container column-start">
        <div class="contenedor-logo">
          <img src="/static/img/UFV-logo.png" alt="Logo UFV">
        </div>
        <h1>Alumnos y alumni</h1>
      </div>

    </div>

    <div class="migas">
      <div class="container">
        <nav class="row-start">
          <router-link to="/">Home</router-link>
          <router-link :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
        </nav>
      </div>
    </div>

    <destacados :position="2"></destacados>

    <section class="accesos -small row-center container ais">

      <article class="column-center ofertas-practicas">
        <div>
          <h2>Ofertas de prácticas</h2>
          <p>Consulta las ofertas de prácticas publicadas.</p>
        </div>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="btn -skull -white">Ver
          ofertas</a>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="enlace-cover"></a>
      </article>
      <article class="column-center programa-practicas">
        <div>
          <h2>Programa de Prácticas Internas</h2>
          <p>Si quieres hacer prácticas
            en la Universidad
            consulta las bases
            del programa.</p>
        </div>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
          class="btn -skull -white">Saber más</a>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="enlace-cover"></a>
      </article>
      <article class="column-center programa-estudia-trabaja">
        <div>
          <h2>Programa Estudia y Trabaja</h2>
          <p>Si quieres trabajar mientras estudias, conoce las empresas que pueden ofrecerte una oportunidad.</p>
        </div>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
          class="btn -skull -white">Saber más</a>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
          class="enlace-cover"></a>
      </article>

      <article class="column-center ofertas-empleo">
        <div>
          <h2>Ofertas de Empleo</h2>
          <p>Si eres Alumni,
            accede a las ofertas
            de empleo publicadas.</p>
        </div>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="btn -skull -white">Ver
          ofertas</a>
        <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="enlace-cover"></a>
      </article>


    </section>


    <section class="proyecto-formativo -practicas">
      <div class="container column-center">
        <h2 class="big-bold-title">Prácticas</h2>
        <p>Las prácticas académicas son una valiosa oportunidad para enriquecer la formación de los estudiantes y
          reforzar su empleabilidad. La Universidad Francisco de Vitoria reconoce su alto valor formativo y pone al
          alcance de sus alumnos los medios necesarios para que puedan aprovechar de manera fecunda esta oportunidad,
          tanto a través de prácticas curriculares como extracurriculares.</p>

        <a href="/static/pdfs/listado-empresa-convenio-activo.pdf" rel="noreferrer" target="_blank"
          class="btn -skull -white">Listado de empresas con convenio activo</a>
      </div>
    </section>




    <!-- <section class="accesos">

      <slick ref="slick" :options="slickOptions">

        <div class="slide">
          <article class="column-center ofertas-practicas">
            <div>
              <h2>Ofertas de prácticas</h2>
              <p>Consulta las ofertas de prácticas publicadas.</p>
            </div>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
              class="btn -skull -white">Ver ofertas</a>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="enlace-cover"></a>
          </article>
        </div>

        <div class="slide">
          <article class="column-center programa-practicas">
            <div>
              <h2>Programa de Prácticas Internas</h2>
              <p>Si quieres hacer prácticas
                en la Universidad
                consulta las bases
                del programa.</p>
            </div>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
              class="btn -skull -white">Saber más</a>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="enlace-cover"></a>
          </article>
        </div>

        <div class="slide">
          <article class="column-center programa-estudia-trabaja">
            <div>
              <h2>Programa Estudia y Trabaja</h2>
              <p>Si quieres trabajar mientras estudias, conoce las empresas que pueden ofrecerte una oportunidad.</p>
            </div>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
              class="btn -skull -white">Saber más</a>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
              class="enlace-cover"></a>
          </article>
        </div>

        <div class="slide">
          <article class="column-center ofertas-empleo">
            <div>
              <h2>Ofertas de Empleo</h2>
              <p>Si eres Alumni,
                accede a las ofertas
                de empleo publicadas.</p>
            </div>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes"
              class="btn -skull -white">Ver ofertas</a>
            <a target="_blank" rel="noreferrer" href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" class="enlace-cover"></a>
          </article>
        </div>

      </slick>


    </section> -->


    <section class="normativa-documentos row-center">

      <div class="contenedor-titulo row-center">
        <h2 class="light-big-title -blue">Normativa y documentos<br>de interés</h2>

        <img src="/static/img/normativa-top.svg" class="normativa-top">
        <img src="/static/img/normativa-left.svg" class="normativa-left">
        <img src="/static/img/normativa-right.svg" class="normativa-right">
        <img src="/static/img/normativa-right-bottom.svg" class="normativa-right-bottom">
        <img src="/static/img/normativa-left-bottom.svg" class="normativa-left-bottom">


        <div class="tip-normativa row-start -reglamento" @mouseover="over1 = true" @mouseleave="over1 = false">
          <div class="texto">
            <h2>Reglamento de prácticas UFV</h2>
            <p class="left">Consulta la normativa de prácticas de la Universidad para las carreras a las que el
              Departamento de Carreras Profesionales UFV da servicio.</p>
            <div class="contenedor-boton row-start">
              <a target="_blank" href="/static/pdfs/Reglamento_De_PrácticasAcadémicas.pdf" class="btn -skull">Ver</a>
            </div>
          </div>
          <img :src="'/static/img/senal-reglamento' + ((over1) ? '-on' : '') + '.svg'" alt="">


        </div>


        <div class="tip-normativa row-start -sistemas" @mouseover="over2 = true" @mouseleave="over2 = false">
          <div class="texto">
            <h2>Sistema de adjudicación</h2>
            <p class="left">Consulta el sistema de adjudicación de plazas de prácticas de la UFV.</p>
            <div class="contenedor-boton row-start">
              <a href="/static/pdfs/sistemas-adjudicacion.pdf" target="_blank" class="btn -skull">Ver</a>

            </div>
          </div>
          <img :src="'/static/img/lupa-adjudicacion' + ((over2) ? '-on' : '') + '.svg'" alt="">
        </div>


        <div class="tip-normativa row-start -practicas" @mouseover="over3 = true" @mouseleave="over3 = false">

          <img :src="'/static/img/guia-de-practicas' + ((over3) ? '-on' : '') + '.svg'" alt="">
          <div class="texto">
            <h2>Guía de prácticas</h2>
            <p class="right">Consulta información detallada sobre cómo buscar prácticas.</p>
            <div class="contenedor-boton row-start">
              <a href="/static/pdfs/guia-de-practicas.pdf" target="_blank" class="btn -skull">Ver</a>
            </div>
          </div>
        </div>

        <div class="tip-normativa row-start -seguro" @mouseover="over4 = true" @mouseleave="over4 = false">
          <img :src="'/static/img/seguro-medico' + ((over4) ? '-on' : '') + '.svg'" alt="">
          <div class="texto">
            <h2>Guía de seguro y coberturas médicas</h2>
            <p class="right">Te facilitamos un resumen de los seguros y coberturas médicas necesarias según el tipo de
              prácticas que realices, así como la forma de proceder en caso de contingencia durante la realización de
              estas.</p>
            <div class="contenedor-boton row-start">
              <a href="/static/pdfs/cuadro-coberturas-medicas.pdf" target="_blank" class="btn -skull">Ver</a>
            </div>
          </div>
        </div>

        <div class="tip-normativa row-start -faqs" @mouseover="over5 = true" @mouseleave="over5 = false">
          <img :src="'/static/img/faqs' + ((over5) ? '-on' : '') + '.svg'" alt="">
          <div class="texto">
            <h2>Preguntas frecuentes</h2>
            <p class="left top">Consulta las preguntas frecuentes que podrán ayudarte a resolver dudas.</p>
            <div class="contenedor-boton row-start">
              <a href="/static/pdfs/preguntas-frecuentes.pdf" target="_blank" class="btn -skull">Ver</a>
            </div>
          </div>
        </div>

      </div>

    </section>


    <section class="proyecto-formativo -empleo">
      <div class="container column-center">
        <h2 class="big-bold-title">Empleo</h2>
        <p>Una vez terminan la carrera, nuestros Alumni cuentan con nosotros para buscar oportunidades donde desarrollar
          su carrera profesional. Podrán acceder a diversas oportunidades profesionales cuidadosamente seleccionadas.
        </p>

        <a href="https://portalcarrerasprofesionales.ufv.es/login/estudiantes" target="_blank" class="btn -skull -white">Accede a ofertas
          de empleo</a>
      </div>
    </section>


    <section class="conectados-home">


      <div class="container row-between ais">


        <img src="/static/img/imagen-conectados.svg" class="imagen-conectados" alt="Imagen Conectados">


        <div class="main-card">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="showsecondarycard" @click="showsecondarycard = false">
          <p>¿Recuerdas tus primeros pasos profesionales? Seguro que sentiste algunos miedos, inseguridades o
            necesitaste orientación y acompañamiento. Tu trayectoria, experiencia y conocimientos son muy valiosos para
            quien ahora comienza.</p>
          <p>¿Quieres apoyar a los jóvenes talentos?</p>
          <div class="boton-redondo"></div>

          <router-link :to="$t('enlaces.conectados') + '/profesional'" class="btn -skull -white">Conecta</router-link>
        </div>

        <div class="secondary-card" :show="showsecondarycard" @click="showsecondarycard = !showsecondarycard">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="!showsecondarycard">
          <p>Conocer en profundidad te ayuda a tomar decisiones. Si tienes dudas sobre un sector, industria, empresa. Te
            enfrentas a un proceso de selección y quieres información para prepararte bien... ante cualquier duda en las
            decisiones sobre tu carrera profesional, te ponemos en contacto con quien puede ayudarte.</p>
          <router-link :to="$t('enlaces.conectados') + '/alumno'" class="btn -skull -white">Conecta</router-link>
        </div>
      </div>

    </section>

    <section class="banners-acceso container row-between ais">

      <article class="protagoniza-tu-futuro">
        <h2>Orientación</h2>
        <p>Tú decides, tú tienes todo que decir respecto
          a tu futuro profesional. Nosotros te acompañamos,
          ofreciéndote formación, talleres,
          mentorías individuales, recursos…</p>
        <router-link :to="$t('enlaces.orientacion')" class="btn -skull -white">ver</router-link>
        <router-link :to="$t('enlaces.orientacion')" class="enlace-cover"></router-link>
      </article>
      <article class="internacional">
        <h2>Internacional</h2>
        <p>La experiencia internacional es un diferencial en cualquier carrera profesional. Desde el departamento te
          ayudamos a hacer realidad esta experiencia.</p>
        <router-link :to="$t('enlaces.internacional')" class="btn -skull -white">ver</router-link>
        <router-link :to="$t('enlaces.internacional')" class="enlace-cover"></router-link>
      </article>

    </section>

    <al-dia-banner :position="2"></al-dia-banner>

  </div>

</template>

<script lang="js">

import bannerconectados from '@/components/parts/banner-conectados';
import aldiabanner from '@/components/parts/al-dia-banner';

import aldia from '@/components/view-parts/home/al-dia';

import Slick from 'vue-slick';

import destacados from '@/components/parts/destacados';

export default {
  name: 'empresas',
  data() {
    return {
      showproyectoformativo: false,
      showempleo: false,
      showsecondarycard: false,
      over1: false,
      over2: false,
      over3: false,
      over4: false,
      over5: false,
      slickOptions: {
        slidesToShow: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 3000,
        variableWidth: false
      },
    }
  },
  components: {
    'banner-conectados': bannerconectados,
    'al-dia-banner': aldiabanner,
    'al-dia': aldia,
    'destacados': destacados,
    Slick
  }
}
</script>

<style scoped lang="scss">
.accesos-home {
  article {
    padding: 65px 20px;
    justify-content: flex-start;


    h2 {
      min-height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &:nth-child(1) {
      background: url(/static/img/acceso-alumni-1.jpg) center/cover no-repeat;
    }

    &:nth-child(2) {
      background: url(/static/img/acceso-alumni-2.jpg) center/cover no-repeat;
    }

    &:nth-child(3) {
      background: url(/static/img/acceso-alumni-3.jpg) center/cover no-repeat;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/alumnos-y-alumni.vue